import React, { useMemo } from 'react';
import { getCurrentDateInMillis, getDescription, getSpecificDateInMillis, formatDollar } from '../../../helpers/utils';
import { usePager } from '../../../helpers/pagination';
import { CongratulationsRunner } from '../CongratulationsRunner';
import SideBar from '../../Common/SideBar';
import PageIndicator from '../../Common/PageIndicator';
import SpotlightHeader from '../../Common/Header';
import LeaderboardTable from '../LeaderboardTable';
import './ProductSalesLeaderboard.scss';
const getFormattedData = (data, metadata) => {
  var _metadata$boh_date_ra;
  const {
    timezone,
    group_name,
    last_row: last_date
  } = data;
  const {
    boh_period,
    boh_date_range,
    results,
    boh_event_type,
    boh_show_dollar_amount,
    boh_compare_stores
  } = metadata;
  const {
    endDate,
    endTime
  } = (_metadata$boh_date_ra = metadata.boh_date_range) !== null && _metadata$boh_date_ra !== void 0 ? _metadata$boh_date_ra : {};
  const description = getDescription(timezone, boh_event_type, boh_period, boh_date_range, `${group_name} sales`, last_date);
  const employees = data.employees.slice(0, results);
  const topEmployeeName = employees[0].name;
  const display_dollar_amount = boh_show_dollar_amount !== false;
  const showCongratulations = boh_event_type === 'custom' && endDate && endTime && getCurrentDateInMillis(timezone) > getSpecificDateInMillis(endDate, endTime, timezone);
  const display_location = boh_compare_stores !== false;
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  return {
    description,
    employees,
    topEmployeeName,
    display_dollar_amount,
    showCongratulations,
    display_location,
    hide_poweredbyupshow
  };
};
const ProductSalesLeaderboard = props => {
  const {
    data,
    metadata,
    text,
    duration,
    playing,
    bohStyle
  } = props;
  const {
    accent_color,
    title_color,
    title_font_family,
    text_accent_color,
    containerStyle,
    listHeaderRowStyle
  } = bohStyle;
  const {
    employees,
    topEmployeeName,
    description,
    showCongratulations,
    display_dollar_amount,
    display_location,
    hide_poweredbyupshow
  } = getFormattedData(data, metadata);
  const [page, pageIdx, pages] = usePager(employees, duration * 1000, showCongratulations ? false : playing);
  const Header = /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: text,
    metadata: metadata,
    description: description,
    isLeaderboard: true
  });
  const tableColumns = useMemo(() => {
    const hiddenColumns = new Set();
    if (display_dollar_amount === false) hiddenColumns.add('sales');
    if (display_location === false) hiddenColumns.add('location');
    return [{
      Header: 'Employee',
      accessor: 'ranking',
      Cell: function Cell(row) {
        const {
          ranking,
          name
        } = row;
        return /*#__PURE__*/React.createElement("div", {
          className: "employee-column"
        }, `${ranking}. ${name}`);
      }
    }, {
      Header: 'Location',
      accessor: 'location',
      headerClassName: 'right',
      rowClassName: 'right'
    }, {
      Header: 'Quantity Sold',
      accessor: 'count',
      headerClassName: 'right',
      rowClassName: 'right'
    }, {
      Header: 'Dollar Amount',
      accessor: 'sales',
      Cell: row => {
        const sales = row.sales;
        if (isNaN(sales)) {
          return /*#__PURE__*/React.createElement("div", {
            className: "sales-column"
          }, "-");
        } else {
          return /*#__PURE__*/React.createElement("div", {
            className: "sales-column"
          }, formatDollar(row.sales));
        }
      },
      headerClassName: 'right',
      rowClassName: 'right'
    }].filter(col => !hiddenColumns.has(col.accessor));
  }, [display_location, display_dollar_amount]);
  return /*#__PURE__*/React.createElement("div", {
    className: "new-product-sales",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(CongratulationsRunner, {
    color: accent_color,
    textColor: title_color,
    firstText: "CONGRATULATIONS!",
    secondText: topEmployeeName,
    header: Header,
    timeout: (duration - 5) * 1000,
    showCongratulations: playing && showCongratulations
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-section"
  }, Header), /*#__PURE__*/React.createElement("div", {
    className: "table-section"
  }, /*#__PURE__*/React.createElement(LeaderboardTable, {
    columns: tableColumns,
    data: page,
    headerStyle: listHeaderRowStyle
  })), !showCongratulations && pages.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: "page-indicator-section"
  }, /*#__PURE__*/React.createElement(PageIndicator, {
    pages: pages,
    current: pageIdx,
    selectedColor: accent_color
  })), /*#__PURE__*/React.createElement(SideBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    logo: metadata.logo,
    text: text.message_board,
    fontFamily: title_font_family,
    hide_poweredbyupshow: hide_poweredbyupshow
  })));
};
export default ProductSalesLeaderboard;